// extracted by mini-css-extract-plugin
export default {"general":"DesktopSelect_general--eQ2","contentClass":"DesktopSelect_contentClass--qk3"};